
<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title" *ngIf="inner_PM.id==0">Add </h5>
    <h5 class="card-title" *ngIf="inner_PM.id>0">Edit </h5>
    <br>
    <br>

    <form [formGroup]="PMForm">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            <button *ngIf="!InProccessing" type="button" style="margin-right: 5px;"
            (click)="openModal_DeviceBehfa(templateDeviceBehfa)" class="btn btn-info left"> Add Behfa Equipment <i
              class="fa fa-building"></i> </button>
          </label>
          <input formControlName="DeviceBehfa_id" type="text" class="form-control" disabled>

        </div>

        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Service Program</label>

          <select class="custom-select" formControlName="Program_id">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_PM_Program" [value]="item.id">{{item.title}}</option>
          </select>
        </div>


      </div>
    </form>




    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />

    <button *ngIf="!InProccessing && inner_PM.id==0" type="button" (click)="SubmitPMForm()" [disabled]="!PMForm.valid"
      class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>

    <button *ngIf="!InProccessing && inner_PM.id>0" type="button" (click)="SubmitPMForm()" [disabled]="!PMForm.valid"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Edit </button>

  </div>
</div>


<ng-template #templateDeviceBehfa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Behfa Equipment List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBehfa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <app-DeviceBehfaActiveList [inner_PersianDate]=""

      (seleted_DeviceBehfa_Interface)="Set_Selected_DeviceBehfa_Record($event)">

    </app-DeviceBehfaActiveList>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBehfa.hide()">Close</button>
  </div>
</ng-template>
